export const MILLI_SECOND = 100
export const SECOND = 10 * MILLI_SECOND
export const MINUTE = 60 * SECOND
export const HOUR = 60 * MINUTE
export const DAYS = 24 * HOUR
